const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const ScaredCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'scared';
	condition.ConditionClass = ScaredCondition;

	const extant = BattleCalc.getCondition( owner, 'scared' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};

ScaredCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return ScaredCondition(instigator, owner, battleState, remainingDuration);
};

module.exports = ScaredCondition
